import {
    FETCH_GRAPH_PRACTICE_INCOME_REQUEST,
    FETCH_GRAPH_PRACTICE_INCOME_SUCCESS,
    FETCH_GRAPH_PRACTICE_INCOME_FAILURE,
  } from "./FetchGraphPracticeIncomeTypes";
  import api from "../../utils/Api";
  
  export const fetchGraphPracticeIncomeRequest = () => {
    return {
      type: FETCH_GRAPH_PRACTICE_INCOME_REQUEST,
    };
  };
  
  export const fetchGraphPracticeIncomeSuccess = (graphDataPracticeIncome) => {
    return {
      type: FETCH_GRAPH_PRACTICE_INCOME_SUCCESS,
      payload: graphDataPracticeIncome,
    };
  };
  
  export const fetchGraphPracticeIncomeFailure = (error) => {
    return {
      type: FETCH_GRAPH_PRACTICE_INCOME_FAILURE,
      payload: error,
    };
  };
  
  export const fetchGraphPracticeIncome = (view_by, practitioner_id) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "/report/practiceincome/graph/fetch?";

    if(view_by === "month"){
        url += "month="+ 1;
    }
    if(view_by === "week"){
        url += "week="+ 1;
    }
    if(practitioner_id){
        url += "&practitioner_id="+ practitioner_id;
    }
    
    return async (dispatch) => {
      dispatch(fetchGraphPracticeIncomeRequest());
      try {
        const response = await api.get(url,
          {
            headers: headers,
          }
        );
        const graphDataPracticeIncome = response.data.data;
        //console.log("****** graph Data practice Income response", graphDataPracticeIncome);
        dispatch(fetchGraphPracticeIncomeSuccess(graphDataPracticeIncome));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchGraphPracticeIncomeFailure(errorMsg));
      }
    };
  };
  